const DIRECTORY_ACCESS = new Map();
DIRECTORY_ACCESS.set('MODIFICATION', 'Modification');
DIRECTORY_ACCESS.set('READ', 'Lecture');

export default DIRECTORY_ACCESS;
